import { useState } from "react"
import { Col, Row } from "react-bootstrap"
import { IoIosCloseCircle } from "react-icons/io"
import { Link } from "react-router-dom"
import FormCorreos from "../../components/correos/FormCorreos"
import useQuery from "../../hook/useQuery"

function AddCorreos(){
    const [edit, setEdit] = useState(true)
    const query = useQuery()
    const id = query.get('id')


    return (
        <>
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top">{`${id ? 'Editar' : 'Agregar'} correo`}</h2>
                </Col>
                <Col xs="12" md="4" className="text-right">
                    <Link to="/admin/correos"><IoIosCloseCircle className="cancel-btn"/></Link>                    
                </Col>
            </Row>
            <FormCorreos id={id} edit={edit} setEdit={setEdit}/>
        </>
    )
}

export default AddCorreos